// inputs/keyboard-input/create-keyboard-input.ts
import { type SelectionsMachine } from '../../machine/selection-machine';
import { type SharedEventLoop } from '../event-loop';
import { type SelectionInput } from '../types';

import { handleKeyDown } from './handle-key-down';

export function createKeyboardInput(
  machine: SelectionsMachine,
  sharedLoop: SharedEventLoop
): SelectionInput {
  let unsubscribe: () => void;

  return {
    setup() {
      unsubscribe = sharedLoop.subscribe((events) => {
        for (const event of events) {
          if (event.type === 'keyboardDown') {
            handleKeyDown(event, machine);
          }
        }
      });
    },

    dispose() {
      unsubscribe?.();
    },
  };
}
